import { fadeOut } from './animate.js';

const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

const AUTH_CONTEXT = {
    'sign-in': {
        title: 'Sign in',
        subtitle: 'Use your DHSB Google account to access school services.',
    },
    authorise: {
        title: 'Authorise app',
        subtitle: 'Enter this code in the app to complete sign-in.',
    },
    generating: {
        title: 'Authorise app',
        subtitle: 'Generating a one-time code for your app…',
    },
};

export function waitForAuthAssets() {
    return Promise.all([
        document.fonts.ready,
        new Promise((resolve) => {
            const logo = document.getElementById('logo');
            if (!logo) {
                resolve();
                return;
            }
            if (logo.complete) {
                resolve();
                return;
            }
            logo.addEventListener('load', resolve, { once: true });
            logo.addEventListener('error', resolve, { once: true });
        }),
    ]);
}

export function revealAuthShell() {
    document.body.classList.add('auth-ready');
}

export function setAuthCardContext(mode) {
    const config = AUTH_CONTEXT[mode] || AUTH_CONTEXT['sign-in'];
    document.getElementById('auth-card-title').textContent = config.title;
    document.getElementById('auth-card-subtitle').textContent = config.subtitle;
}

export function showCodeGeneratingUI() {
    setAuthCardContext('generating');
    setAuthView('message');
    document.getElementById('message').innerHTML = `
        <div class="auth-loading code-generating">
            <div class="spinner" aria-hidden="true"></div>
            <p>Generating login code…</p>
        </div>`;
    document.getElementById('copy-code').classList.add('auth-panel-hidden');
    revealAuthShell();
}

export function setAuthView(view) {
    const progress = document.getElementById('login-progress');
    const options = document.getElementById('login-options');
    const message = document.getElementById('message');
    const copyCode = document.getElementById('copy-code');
    const actions = document.querySelector('.auth-card-actions');

    const show = (element, visible) => {
        if (!element) {
            return;
        }
        element.classList.toggle('auth-panel-hidden', !visible);
    };

    show(progress, view === 'checking');
    show(options, view === 'login');
    show(message, view === 'message');
    show(copyCode, view === 'message');
    show(actions, view !== 'message');
}

export async function prepareAuthEntry() {
    await Promise.all([
        waitForAuthAssets(),
        delay(350),
    ]);
}

export async function returnToAuth({ message = '', showLogin = true } = {}) {
    const auth = document.getElementById('auth');
    const app = document.getElementById('app');
    const loginDesc = document.getElementById('login-desc');

    window.loginComplete = false;
    window.generatingCode = false;

    setAuthCardContext('sign-in');
    setAuthView(showLogin ? 'login' : 'checking');

    if (message) {
        loginDesc.innerText = message;
        loginDesc.classList.remove('auth-panel-hidden');
    } else {
        loginDesc.innerText = '';
        loginDesc.classList.add('auth-panel-hidden');
    }

    document.getElementById('copy-code-btn')?.classList.remove('copied');
    document.getElementById('copy-code-btn')?.removeAttribute('disabled');

    if (!app.classList.contains('is-hidden')) {
        await fadeOut(app);
    }

    app.classList.add('is-hidden');
    auth.classList.remove('is-hidden');
    revealAuthShell();

    auth.classList.add('view-enter');
    auth.addEventListener('animationend', () => auth.classList.remove('view-enter'), { once: true });
}
